import { render, staticRenderFns } from "./UserHelp.vue?vue&type=template&id=6a108848&scoped=true&"
import script from "./UserHelp.vue?vue&type=script&lang=js&"
export * from "./UserHelp.vue?vue&type=script&lang=js&"
import style0 from "./UserHelp.vue?vue&type=style&index=0&id=6a108848&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a108848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a108848')) {
      api.createRecord('6a108848', component.options)
    } else {
      api.reload('6a108848', component.options)
    }
    module.hot.accept("./UserHelp.vue?vue&type=template&id=6a108848&scoped=true&", function () {
      api.rerender('6a108848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserHelp.vue"
export default component.exports